import { Question } from "./types";

export const questions: Question[] = [
  {
    id: "name",
    question: "What's the name of your property?",
    placeholder: "e.g. Oceanview Villa",
    type: "input",
    inputType: "text",
  },
  {
    id: "location",
    question: "Where is this property located?",
    placeholder: "Enter address or drop a pin",
    type: "location",
    inputType: "text",
  },
  {
    id: "pricePerNight",
    question: "What's the price?",
    placeholder: "0.00",
    type: "price",
    prefix: "$",
    inputType: "number",
  },
  {
    id: "checkInTime",
    question: "What are the check-in and check-out times?",
    placeholder: "Select times",
    type: "time",
  },
  {
    id: "images",
    question: "Add photos that showcase your property",
    placeholder: "Upload images",
    type: "images",
  },
];
